import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <main>
        <Navbar />
        <div className="pt-20 min-h-[80vh] flex items-center justify-center bg-background-50">
          <div className="text-center px-4">
            <h1 className="text-8xl md:text-[10rem] font-heading font-black text-primary-100 select-none">
              404
            </h1>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mt-4 mb-2">
              页面未找到
            </h2>
            <p className="text-foreground-500 text-sm mb-1 font-mono">
              {location.pathname}
            </p>
            <p className="text-foreground-500 text-sm mb-6">
              您访问的页面不存在或已被移除
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line"></i>
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}